import { Tooltip } from 'antd';
import styled from 'styled-components';

export default styled(Tooltip)`
	// Add your styles here
`;
